import React from 'react';
import { styled, Stack, Typography } from "@mui/material";
const Card = styled(Stack)(({ theme }: any) => ({
  boxShadow: "5px 5px 50px rgba(0, 0, 0, 0.25)",
  height: "94px",
  backdropFilter: `blur(3px)`,
  backgroundColor: "rgba(255, 255, 255, 0.25)",
  border: "2px solid rgba(255, 255, 255, 0.27)",
  width: "272px",
  padding: `10px 20px`,
  borderRadius: "15px",
  "& .description": {
    overflowWrap: "break-word",
    fontSize: `${theme.typography.h5.fontSize}!important`,
  },
}));
interface CardInterface {
  title: string;
  description?: string;
  icon?: string;
}
const AnalyticsCard = ({
  title,
  description,
  icon = "far fa-boxes-alt",
}: CardInterface) => {
  return (
    <Card
      direction="row"
      justifyContent="space-around"
      alignItems="center"
      spacing={1.75}
    >
      <i className={`${icon} fa-3x font-white`} />
      <Stack spacing={0.75}>
        <Typography color="primary" variant="h4">
          {title}
        </Typography>
        <Typography color="white" className="description">
          {description}
        </Typography>
      </Stack>
    </Card>
  );
};
export default AnalyticsCard;
